// @flow

import React from 'react';
import bemify from 'bemify-js';

import Link from 'web-ssr/app/common/components/Link';
import { buildStaticAssetPath } from 'web-ssr/app/common/next/utils';
import 'web-ssr/app/common/components/Logo.scss';

const bem = bemify('logo');

type Props = {
  className?: string,
};

const Logo = (props: Props) => {
  const { className = '' } = props;
  const path = buildStaticAssetPath('images/zapier-small-orange-logo.png');

  return (
    <Link className={bem(className)} href="/">
      <img alt="Zapier Logo" className={bem('__image')} src={path} />
    </Link>
  );
};

export default Logo;
